import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import useGetFormulaMessageContents from '../formulas/useGetFormulaMessageContent';
import useHandleQueryParams from '../helper/useHandleQueryParams';
import useLanguagesQuery from '../languages/useLanguagesQuery';

export default function useGetCurrentMessageContent(formulaId?: number): {
    currentMessageContentId?: string;
    isLoading: boolean;
} {
    const { formulaId: formulaIdParam } = useParams<{ formulaId: string }>();
    const [queryParams] = useHandleQueryParams();

    const messageContentId = useMemo<string | undefined>(
        () => queryParams.messageContentId as string | undefined,
        [queryParams],
    );

    const { data: messageContents, isLoading } = useGetFormulaMessageContents(
        formulaId || +formulaIdParam!,
    );
    const { data: languages } = useLanguagesQuery();

    const defaultLanguageId = useMemo<string | undefined>(
        () => languages?.find((language) => language.is_default)?.id,
        [languages],
    );

    const defaultMessageContentId = useMemo<string | undefined>(
        () =>
            messageContents?.find(
                (content) => content.language_id === defaultLanguageId,
            )?.id,
        [messageContents, defaultLanguageId],
    );

    const currentMessageContentId = useMemo<string | undefined>(
        () => messageContentId || defaultMessageContentId,
        [messageContentId, defaultMessageContentId],
    );

    return { currentMessageContentId, isLoading };
}
